import { atom } from 'jotai';
import { Project, User } from '../types';

interface State {
  isOpen: boolean;
  project?: Project;
  user?: User;
}

export const removeUserFromProjectConfirmDialogAtom = atom<State>({
  isOpen: false,
  project: undefined,
  user: undefined,
});
